// import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import React, {useState, useEffect} from 'react';



function App() {


  const [input, setInput]= useState("")  // input for summoner search

  const [matchList, setMatchList] = useState([]) // store match data
  const [rankedData, setRankedData] = useState([]) // store ranked data
  const [summonerData, setSummonerData] = useState([]) // store summoner data

  const [server, setServer] = useState("europe"); 
  const [region, setRegion] = useState("euw1"); // default region for EUW server

  const [tacticianJSON, setTacticianJSON] = useState(null); // load on page load
  const [latestPatch, setLatestPatchVersion] = useState(null);
  const [tftJSON, setTFTJSON] = useState(null);

  // local/live server endpoints
  const Local= 'http://localhost:4000/allData'; 
  const Vercel = 'https://tfttracker-server.vercel.app/allData'; 


  


  

  function getPlayerData(event) {  
    
    const [summonerName, tagLine] = input.split("#");
    if(!input.trim()){


      alert("Please enter a player name and tag!");
      return;
    }
    

    axios.get(Vercel, {params: {summonerName: summonerName, tagLine: tagLine, server: server, region: region}})
    .then(res => {
      setMatchList(res.data.matchList);
      setSummonerData(res.data.summonerData);
    
      setRankedData(res.data.tftRankedData);
    }).catch(error => {
      if (error.response && error.response.status === 429) {
        alert("Too many requests. Please wait and try again.");
      } else {
        console.log(error);
      }
    });

                 
  }


    function getTacticianImage(tacticianID){
      try{
        return tacticianJSON.data[tacticianID].image.full;

      }catch(error){
        console.error("Error fetching tactician image:", error);

      }
      
    }

    
    

   // Function to get the champion image based on the champion ID
    
    function getChampionImage(championID){

      try{
        


        // riot champion naming convention inconsistent, enforce correct formatting for API calls
        const championIDPath = championID.substring(0, 6).toUpperCase() + championID.charAt(6).toUpperCase() + championID.slice(7); 

        
        
        
        console.log(championIDPath); // Debugging
        if(championIDPath.includes('TFT13') ){
          return `https://raw.communitydragon.org/15.15/game/assets/characters/${championIDPath.toLowerCase()}/hud/${championIDPath.toLowerCase()}_square.tft_${championIDPath.substring(3,5)}.png`;
             


        } else if(championIDPath.includes('TFT14')){
   
          return `https://raw.communitydragon.org/15.15/game/assets/characters/${championIDPath.toLowerCase()}/hud/${championIDPath.toLowerCase()}_square.tft_${championIDPath.substring(3,5)}.png`;
          
          
        } else if (championIDPath.includes('TFT15')) {

          return `https://raw.communitydragon.org/15.15/game/assets/characters/${championIDPath.toLowerCase()}/hud/${championIDPath.toLowerCase()}_square.tft_${championIDPath.substring(3,5)}.png`;

        } else if (championIDPath.includes('TFT16')) {
         
          return `https://raw.communitydragon.org/16.4/game/assets/characters/${championIDPath.toLowerCase()}/hud/${championIDPath.toLowerCase()}_square.tft_set${championIDPath.substring(3,5)}.png`;
        } else if (championIDPath.includes('TFT17')) {
          


          console.log("Fetching image for TFT17 champion:", championIDPath); // Debugging
          return `https://raw.communitydragon.org/16.13/game/assets/characters/${championIDPath.toLowerCase()}/hud/${championIDPath.toLowerCase()}_square.tft_set${championIDPath.substring(3,5)}.png`
          ;
        }
      

      }catch (error){
         
      
        console.error("Error fetching unit images:", error);
      } 
    
      
    } 

  
    useEffect(() => {

     
        
      async function fetchJSON(){

       try{
           const Patchresponse = await fetch('https://ddragon.leagueoflegends.com/api/versions.json');

           const latestPatchVersion = await Patchresponse.json(); 

           setLatestPatchVersion(latestPatchVersion[0]); // Set the latest patch version

           

           const tacticianResponse = await fetch('https://ddragon.leagueoflegends.com/cdn/'+latestPatchVersion[0]+'/data/en_GB/tft-tactician.json'); // retrieve latest tacticians

           const tactician = await tacticianResponse.json();
           setTacticianJSON(tactician);
          
           const tftDataRes = await fetch('https://raw.communitydragon.org/' + latestPatchVersion[0].split('.').slice(0, 2).join('.') + '/cdragon/tft/en_us.json')
           
           const tftData = await tftDataRes.json();
           setTFTJSON(tftData);

  
          

         
        }catch(error){
          console.error("Error fetching data:", error);
   
        }
   
       }
       
       fetchJSON();

    }, [])

   


  const SERVERS = {

    euw1: { label: 'EUW', server: 'europe' },
    eun1: { label: 'EUNE', server: 'europe' },
    na1: { label: 'NA', server: 'americas' },
    kr: { label: 'KR', server: 'asia' },
  }
  

  return (
    <div className="App">


          <header className= "App-header">
          
          <div className = "search">  <input type="puuid" placeholder="Search Player#Tag and select Region" onChange={e => setInput(e.target.value)}></input>
          <button className = "hover:scale-110 duration:500" onClick={getPlayerData}>Search</button>
          <select
              value={region}
              onChange={e => {
                const r = e.target.value;
                setRegion(r);
                setServer(SERVERS[r].server);
              }}
            >
              {Object.entries(SERVERS).map(([value, { label }]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </div>
          </header>

          
       
      <>
  {summonerData.profileIconId ? (
    <>
       <div className = "rankInfo">
       <img 
        className = "rounded-full border-4 border-orange-200 border-x-orange-400" 
        src={"https://ddragon.leagueoflegends.com/cdn/"+latestPatch+"/img/profileicon/" + summonerData.profileIconId +".png"}
        alt="Profile icon"
        width="100"
        height="100"/>
      
      
      {rankedData && rankedData.tier ? (
    <img
      src={
        "https://tfttracker-server.vercel.app/assets/" +
        rankedData.tier +
        ".png"
      }
      width="100"
      height="100"
      alt={rankedData.tier}
    />
  ) : (
    <img
      src="https://tfttracker-server.vercel.app/assets/unranked.png" // Fallback image for unranked players
      width="100"
      height="100"
      alt="Unranked"
    />
  )}
       
      
          {rankedData && rankedData.tier && rankedData.rank  ? (
      <p>
        {rankedData.tier} {rankedData.rank} {rankedData.leaguePoints} LP
      </p>
    ) : (
      <p> Unranked</p>
    )}
      
      <p> Wins: {rankedData && rankedData.wins ? rankedData.wins : 0}     </p>
      <p> Losses:  {rankedData && rankedData.losses ? rankedData.losses : 0}</p>
      
    

      
     

      {rankedData && (rankedData.wins || rankedData.losses) ? (
    <p>
      <p> Win Rate: {((rankedData.wins / (rankedData.wins + rankedData.losses)) * 100).toFixed(1)}%</p>      
      </p>
  
     ) : (
     <p>  Win Rate: {0} </p>
    )}


      {rankedData && (rankedData.wins || rankedData.losses) ?(
    <p>
      Games:  {(rankedData.wins) + (rankedData.losses)}
    </p>
  
    ) : (
     <p> Games: {0} </p>
    )}
  
     

      </div>
    </>
  ) : (
   
    console.log("No data available")
  )}
</>
         
             

        <React.Fragment>
        
           {
             matchList.map((matchData, index) => 
               <React.Fragment key ={index}>
          
                
                 
                <div className = "matchInfo overflow-auto rounded-lg shadow">
                
                <div className = "font-montserrat text-center font-semibold text-gray-800 p-10">     
                <p> {new Date(matchData.info.game_datetime).toUTCString()} </p>
                <p>  Duration: {`${Math.floor(matchData.info.game_length / 60)}:${Math.floor(matchData.info.game_length % 60) < 10 ? '0' : ''}${Math.floor(matchData.info.game_length % 60)}`} </p>


            
    
                
                </div>
           
                

                <table className= "w-full " >
                  <thead class = "bg-gray-50 border-b-2 border-gray-200">
                    <tr className = "font-montserrat">
                      <th class = "w-5 p-3 text-sm font-montserrat font-[600] tracking-wide text-left">No.</th>
                      <th class = "w-5 p-3 text-sm font-montserrat font-[600] tracking-wide text-left">Tactician</th>
                      <th class = "w-20 p-3 text-sm font-montserrat font-[600] tracking-wide text-left">Player</th>
                      <th class = "w-20 p-3 text-sm font-montserrat font-[600] tracking-wide text-left">Elim</th>
                      <th class = "w-50 p-3 text-sm font-montserrat font-[600] tracking-wide text-left" >Units</th>
                    </tr>
                  </thead>

                  <tbody>
                {matchData.info.participants
            .sort((a, b) => a.placement - b.placement) // Sort participants by placement
            .map((data, pIndex) => (

              <tr class = {pIndex % 2 === 0 ? "bg-blue-100" : "bg-grey whitespace-nowrap" } key={pIndex}>
              <td className = "p-3 text-sm text-gray-700 whitespace-nowrap gap-4">{data.placement}</td>
              <td className = "p-3 text-sm text-gray-700 whitespace-nowrap gap-4"> 
                 <div >   
                  <img className ='rounded-md border-4 border-orange-200 border-x-orange-400 h-16 w-16' src={"https://ddragon.leagueoflegends.com/cdn/"+latestPatch+"/img/tft-tactician/" + getTacticianImage(data.companion.item_ID)} 
                alt="Tactician" 
                 /> </div>  
                
              </td>
              <td className = "p-3 text-sm text-gray-700 hover:underline whitespace-nowrap gap-4">
                
                
               {data.riotIdGameName}</td>
              <td class = "p-3 text-sm text-gray-700 whitespace-nowrap gap-4"> {`${Math.floor(matchData.info.game_length / 60)}:${Math.floor(matchData.info.game_length % 60) < 10 ? '0' : ''}${Math.floor(matchData.info.game_length % 60)}`}
              </td>

              <td className = "p-3 text-sm text-gray-700 whitespace-nowrap gap-4">
              <div className = 'flex flex-wrap gap-4'>
              {data.units.map((units, unitIndex) => {
              const championImageSrc = 
              units.character_id === "TFT13_Sion" 
              ? "https://ddragon.leagueoflegends.com/cdn/15.6.1/img/champion/Sion.png"
              : units.character_id === "TFT13_JayceSummon"
              ? "https://tfttracker-server.vercel.app/assets/TFT13_JayceSummon.png"
              : units.character_id === "TFT13_Viktor"
              ? "https://ddragon.leagueoflegends.com/cdn/15.6.1/img/champion/Viktor.png"
              : units.character_id === "TFT13_MissMage"
              ? "https://ddragon.leagueoflegends.com/cdn/15.6.1/img/champion/Mel.png"
              : units.character_id === "TFT13_Warwick"
              ? "https://tfttracker-server.vercel.app/assets/TFT13_Warwick.png"
              : units.character_id.includes('TFT14_Summon_Turret')
              ? "https://tfttracker-server.vercel.app/assets/TFT14_Summon_Turret.png"
              : units.character_id.includes('TFT13') || units.character_id.includes('tft13')
              ? getChampionImage(units.character_id)
              : units.character_id.includes('TFT14')
              ? getChampionImage(units.character_id)
              : units.character_id.includes('TFT15_Galio')
              ? `https://tfttracker-server.vercel.app/assets/mighty-mech.png`
              : units.character_id.includes('TFT17_Rhaast')
              ? `https://raw.communitydragon.org/16.13/game/assets/characters/tft17_rhaast/hud/tft17_kayn_slay_square.tft_set17.png`
              : getChampionImage(units.character_id);
              





              let unitborder = "border-gray-400";


            switch (units.rarity) {
                    case 0:
                      unitborder = "border-gray-400"; // Gray
                      break;
                    case 1:
                      unitborder = "border-green-400"; // Green
                      break;
                    case 2:
                     unitborder= "border-blue-400"; // Blue
                      break;
                    case 4:
                      unitborder = "border-purple-500"; // Purple
                      break;
                    case 6:
                      unitborder = "border-yellow-400"; // Yellow/Gold
                      break;
                    default:
                      unitborder = "border-gray-400";
                  }

              
              
              return (
               

                  <div key={unitIndex} className="flex flex-col items-center">
 
    <div className="flex mb-1 select-none">
    {Array.from({ length: units.tier }).map((_, i) => (
        <span
          key={i}
          className={
            units.tier === 1
              ? "text-transparent"
              : units.tier === 2
              ? "text-gray-400"
              : units.tier === 3
              ? "text-yellow-400"
              : units.tier >= 4
              ? "text-sky-400"
              : "text-gray-400"
          }
        style={{ fontSize: "1.2rem", marginRight: "1px" }}
      > 

        
        ★
      </span>
    ))}
  </div>
  <img
    className={`rounded-md border-[5px] ${unitborder} h-32 w-32`}
    src={championImageSrc}
    alt={`${units.character_id}`}
    loading="lazy"
  />
  <span className="flex flex-row flex-wrap justify-center gap-1 mt-1">
  {units.itemNames && units.itemNames.length > 0 &&
    units.itemNames.map((itemName, idx) => {
      let itemPatch = latestPatch; // default
      if (units.character_id.includes('TFT13')) {
        itemPatch = '15.6.1';
      } else if (units.character_id.includes('TFT14')) {
        itemPatch = '15.14.1';
      } else if (units.character_id.includes('TFT15')) {
        itemPatch = '15.15.1';
      }
      return (
        <img
          key={idx}
          src={`https://ddragon.leagueoflegends.com/cdn/${itemPatch}/img/tft-item/${itemName}.png`}
          alt={itemName}
          className="rounded-md border-5 w-8 h-8 inline-block"
          loading="lazy"
        />
      );
    })
  }
</span>
</div>

                
              );
            })}
                </div>
              </td>
              
            </tr>
             ))}
            </tbody>
            </table>
          </div>
         </React.Fragment>
             )
           }
        </React.Fragment>

      
    </div>
  );

}

export default App;
